export default __webpack_public_path__ + "static/media/map.4ebb3625.svg";